module.exports = __webpack_public_path__ + "static/media/p2_bkg.20308880.png";